export default {
    devices_tab_label: 'Label',
    devices_tab_status: 'Status',
    devices_tab_reference: 'Reference',
    devices_tab_manufacturer: 'Manufacturer',
    devices_tab_model: 'Model',
    devices_tab_serial: 'Serial',
    devices_tab_imei: 'IMEI',
    devices_tab_linked_device_label: 'Paired Unit',
    devices_tab_linked_device: 'GPS Unit ESN',
    devices_tab_sim_number: 'SIM #',
    devices_tab_sim_phone: 'SIM Phone',
    devices_tab_network: 'Network',
    devices_tab_sim_provider_account: 'SIM Provider Account',
    devices_tab_unit_time: 'Unit Time',
    devices_tab_server_time: 'Server Time',
    devices_tab_last_message_time: 'Last Message Time',
    devices_tab_age: 'Age',

    devices_tab_edit: 'Edit',
    devices_tab_editswap_sim_card: 'Edit & Swap Sim Card',
    devices_tab_send_command: 'Send Command',
    devices_tab_change_device_script: 'Change Script',
    devices_tab_change_sim_provider: 'Change SIM Provider',
    devices_tab_refresh_config_status: 'Refresh Config Status',
    devices_tab_change_PULS_customer: 'Change Calamp Account',
    devices_tab_bulk_vidfleet_Config: 'Bulk Vidfleet Config',
    devices_tab_assign_firmware: 'Assign Firmware',
    devices_tab_activate_cameras_sim_card: 'Activate Camera´s SIM Card',
    devices_tab_bulk_vidfleet_config_upload_mode: 'Bulk Vidfleet Config Upload Mode',
    devices_tab_bulk_pairing: 'Bulk Pairing',
    devices_tab_unpair: 'Unpair',
    devices_tab_firmware: 'Firmware',
    devices_tab_move_to_another_account: 'Move to another account',
    devices_tab_mark_as_rma: 'Mark as RMA',
    devices_tab_change_status: 'Change Status',
    devices_tab_change_status_warning: 'It is not possible to change the status to refurbished devices',
    devices_tab_sim_provider: 'SIM Provider',
    devices_tab_puls_group: "Group",
    devices_tab_rma_selected: "There are RMA devices selected",
    devices_tab_linked_camera: 'Camera ESN',
    devices_tab_change_timezone: 'Change Timezone',
    devices_tab_change_timezone_warning: 'It is not possible to change the timezone to refurbished devices',
    devices_tab_change_warning_message_calamp_api: 'The selected devices must be of the same calamp api',
    devices_tab_bulk_vidfleet_config_hubspot: 'Bulk Vidfleet Config HotSpot',
    devices_tab_id: "Id",
    devices_tab_change_status_active_message: "The status of active devices cannot be changed",
    devices_tab_assign_unassign_billing_account: "Assign/Unassign Billing Account",
};







